import ConsumerPortalProfile from "features/consumerPortalProfile/consumerPortalProfile";

function ProfilePage() {
  return <ConsumerPortalProfile />;
}

export default ProfilePage;
